/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type TransportKind = typeof TransportKind[keyof typeof TransportKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransportKind = {
  Bus: 'Bus',
  Boat: 'Boat',
  Train: 'Train',
} as const;
